import { DIAGNOSIS_STEP_TYPES } from './matching_assessment_diagnosis_steps';
/**
 * 診断ステップ
 */
export class MatchingAssessmentDiagnosisStep {
    constructor(data, config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stepType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isMultipleChoice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "choices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
        this.stepType = data.stepType;
        this.title = data.title;
        this.isMultipleChoice = data.isMultipleChoice;
        this.choices = data.choices.map((c) => new MatchingAssessmentDiagnosisChoice(c, config));
    }
    get isMotivationStep() {
        return this.stepType === DIAGNOSIS_STEP_TYPES.current_motivation_level;
    }
}
/**
 * 診断ステップの選択肢
 */
export class MatchingAssessmentDiagnosisChoice {
    constructor(data, config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "label", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "iconSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
        this.label = data.label;
        this.iconSrc = data.iconSrc;
    }
    get resolvedIconUrl() {
        if (!this.iconSrc)
            return '';
        if (this.iconSrc.startsWith('/'))
            return this.iconSrc;
        return `${this.config.cdnBaseURL}${this.iconSrc}`;
    }
}
/**
 * 診断ステップの回答
 */
export class MatchingAssessmentDiagnosisAnswer {
    constructor(stepType, choiceLabels) {
        Object.defineProperty(this, "stepType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "choiceLabels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.stepType = stepType;
        this.choiceLabels = choiceLabels;
    }
    static createParam(step, choices) {
        return new MatchingAssessmentDiagnosisAnswer(step.stepType, choices.map((c) => c.label));
    }
    static createEmpty(step) {
        return new MatchingAssessmentDiagnosisAnswer(step.stepType, []);
    }
}
/**
 * 診断回答をAPIリクエストパラメータに変換する
 *
 * answers: LocalStorageに保存された回答 (stepType/choiceLabels)
 */
export function convertDiagnosisAnswersToProfileParams(answers) {
    const labelsByStepType = new Map(answers.map((answer) => [answer.stepType, answer.choiceLabels]));
    const resolveLabels = (stepType) => labelsByStepType.get(stepType) || [];
    const resolveLabel = (stepType) => resolveLabels(stepType)[0] || '';
    return {
        user_primary_goal: resolveLabel(DIAGNOSIS_STEP_TYPES.user_primary_goal),
        target_timeframe: resolveLabel(DIAGNOSIS_STEP_TYPES.target_timeframe),
        current_priority: resolveLabel(DIAGNOSIS_STEP_TYPES.current_priority),
        lifestyle_type: resolveLabel(DIAGNOSIS_STEP_TYPES.lifestyle_type),
        weekday_available_time: resolveLabel(DIAGNOSIS_STEP_TYPES.weekday_available_time),
        habits: resolveLabels(DIAGNOSIS_STEP_TYPES.habits),
        lunch_habit: resolveLabel(DIAGNOSIS_STEP_TYPES.lunch_habit),
        meals_per_day: resolveLabel(DIAGNOSIS_STEP_TYPES.meals_per_day),
        snack_timing: resolveLabel(DIAGNOSIS_STEP_TYPES.snack_timing),
        alcohol_frequency: resolveLabel(DIAGNOSIS_STEP_TYPES.alcohol_frequency),
        appetite_trigger: resolveLabels(DIAGNOSIS_STEP_TYPES.appetite_trigger),
        last_weight_loss_timeframe: resolveLabel(DIAGNOSIS_STEP_TYPES.last_weight_loss_timeframe),
        past_diet_types: resolveLabels(DIAGNOSIS_STEP_TYPES.past_diet_types),
        motivation_trend: resolveLabel(DIAGNOSIS_STEP_TYPES.motivation_trend),
        current_motivation_level: parseInt(resolveLabel(DIAGNOSIS_STEP_TYPES.current_motivation_level), 10) || 0,
        continuation_concerns: resolveLabels(DIAGNOSIS_STEP_TYPES.continuation_concerns),
        desired_outcomes: resolveLabels(DIAGNOSIS_STEP_TYPES.desired_outcomes),
        ideal_outcome: resolveLabel(DIAGNOSIS_STEP_TYPES.ideal_outcome),
        desired_emotion: resolveLabel(DIAGNOSIS_STEP_TYPES.desired_emotion),
    };
}
